const GIFT_WRAP_DEFAULT_NO_WRAP_ID = '510002';
const GIFT_WRAP_MSG_MAX_LENGTH = 125;
const GIFT_CARD_MSG_MAX_LENGTH = 125;
const INTERSTICE_DELAY_MS = 1000; //1000 ms delay for interstice for checkout,

const PAYMENT_LOGO_SIZE = {
    width: 50,
    height: 32
};

module.exports = {
    GIFT_WRAP_DEFAULT_NO_WRAP_ID,
    GIFT_WRAP_MSG_MAX_LENGTH,
    GIFT_CARD_MSG_MAX_LENGTH,
    INTERSTICE_DELAY_MS,
    PAYMENT_LOGO_SIZE
};
